import ChatWidget from '../../widgets/ChatWidget';
import { tryFetch } from '../../widgetLoader';
import { loadWidgetData, applyWidgetData, RELOAD_INTERVAL } from './common';

const DATA = [ 'eventTypes', 'giftTypes', 'giftThresholds', 'textReplacements', 'serviceIcons', 'userData' ];

// transformSettings turns the host's settings into what ChatWidget takes (overlay chat layers derive their direction).
export default async function mountChat(host, transformSettings = s => s) {
	const widget = new ChatWidget({
		container: host.container,
		soundManager: host.soundManager,
		voiceApi: host.voiceApi,
		mmlApi: host.mmlApi,
		baseUrl: host.baseUrl,
	});
	const loadData = async () => {
		const data = await loadWidgetData(host, DATA);
		return { ...data, settings: transformSettings(data.settings) };
	};
	await widget.init(await loadData());

	host.onSettingsChange(s => widget.applySettings(transformSettings(s)));
	const reload = async () => applyWidgetData(widget, await loadData());

	host.subscribe({
		reconnect: reload,
		chat: data => widget._onChat(data),
		userTextReplacementsChange: data => widget.applyTextReplacements(data),
		userEventTypeChange: data => widget.applyEventType(data.eventType, data.data),
		userGiftTypeChange: data => widget.applyGiftType(data.serviceId, data.giftType, data.data),
		userGiftThresholdsChange: async () => {
			const d = await tryFetch(() => host.api.get(`widget/${encodeURIComponent(host.hash)}/giftThresholds`), `cache-${host.hash}-giftThresholds`);
			if(d) widget.applyGiftThresholds(d);
		},
	});

	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => widget.destroy());
}
